var _ellipse, _path, _path2, _ellipse2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlaytechTwo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.289,
    cy: 10.727,
    fill: "#8B5E02",
    rx: 8.863,
    ry: 8.753
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AD8B2C",
    fillRule: "evenodd",
    d: "M13.4 2.228a8.868 8.868 0 00-4.233-.01l2.137 7.832L13.4 2.228zM4.89 4.652l5.806 5.752-7.915-2.12a8.732 8.732 0 012.11-3.632zm14.913 3.655a8.782 8.782 0 00-2.13-3.648l-5.78 5.73 7.91-2.082zm-9.117 2.758l-5.78 5.73a8.779 8.779 0 01-2.13-3.649l7.91-2.081zm9.112 2.105l-7.915-2.12 5.805 5.751a8.731 8.731 0 002.11-3.63zm-6.386 6.066l-2.138-7.833-2.094 7.823a8.877 8.877 0 004.232.01z",
    clipRule: "evenodd",
    opacity: 0.45
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F6DFAF",
    fillRule: "evenodd",
    d: "M10.947 10.151L8.809 2.32a8.755 8.755 0 00-3.66 2.086l5.798 5.746zm2.798-7.84a8.987 8.987 0 013.677 2.11l-5.775 5.72 2.098-7.83zm-3.14 8.43L2.68 8.619a8.66 8.66 0 00.013 4.205l7.91-2.081zm9.28-2.11a8.66 8.66 0 01.012 4.205l-7.923-2.124 7.91-2.081zM8.832 19.143l2.098-7.83-5.775 5.72a8.98 8.98 0 003.677 2.11zm8.596-2.094l-5.798-5.746 2.138 7.832a8.755 8.755 0 003.66-2.086z",
    clipRule: "evenodd"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.299,
    cy: 10.736,
    fill: "#303030",
    fillOpacity: 0.372,
    stroke: "#FFDF98",
    strokeWidth: 0.786,
    rx: 9.429,
    ry: 9.312
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B2C00",
    stroke: "#3B2C00",
    strokeWidth: 1.886,
    d: "M14.241 16.892a4.416 4.416 0 001.125-.303c.337-.144.597-.317.781-.52a.936.936 0 00.258-.696c-.013-.263-.163-.541-.449-.836-.13.265-.346.462-.644.592-.3.13-.641.223-1.027.277a9.429 9.429 0 01-1.01.088c-.453.029-1.117.038-1.99.029-.874-.01-1.903.068-3.087.234-.908.128-1.809.316-2.7.564.137-.248.514-.574 1.129-.978.615-.403 1.345-.867 2.19-1.39.845-.525 1.726-1.089 2.642-1.693a17.36 17.36 0 002.443-1.928c.712-.682 1.246-1.378 1.6-2.088.353-.71.39-1.434.11-2.17-.286-.753-.86-1.254-1.724-1.503-.863-.249-1.804-.302-2.823-.159-.743.104-1.48.3-2.212.588A7.585 7.585 0 006.95 6.06c-.537.419-.93.892-1.179 1.42-.249.529-.265 1.078-.049 1.646.146.385.492.702 1.036.952s1.133.33 1.767.241a1.06 1.06 0 00.16-.036c.052-.016.105-.027.16-.035.208-.065.347-.12.417-.164.07-.045.112-.087.127-.124-.02-.05-.046-.082-.08-.094-.62-.107-1.016-.386-1.188-.838-.178-.469-.197-.92-.058-1.353.14-.434.378-.82.714-1.158.335-.338.75-.62 1.243-.848a5.587 5.587 0 011.566-.458c.799-.112 1.39-.063 1.775.148.384.21.64.483.767.817.23.603.107 1.236-.365 1.902-.472.665-1.13 1.339-1.972 2.021a46.665 46.665 0 01-2.798 2.084c-1.021.707-1.97 1.396-2.847 2.065s-1.6 1.325-2.167 1.969c-.567.643-.801 1.249-.702 1.817.007.016.083.027.23.033.148.006.304-.003.47-.026.302-.042.524-.144.666-.305.223-.33.485-.557.787-.678.301-.122.728-.222 1.278-.299a9.162 9.162 0 011.802-.067c.622.035 1.25.084 1.882.145.632.061 1.274.108 1.924.14.65.032 1.292.004 1.925-.085z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    stroke: "url(#paint1_linear)",
    strokeWidth: 0.5,
    d: "M14.115 16.399c.413-.058.788-.16 1.125-.303.337-.144.597-.318.781-.52a.936.936 0 00.258-.696c-.013-.263-.163-.542-.449-.836-.13.265-.346.462-.644.592-.299.13-.641.222-1.027.277a9.429 9.429 0 01-1.01.088c-.453.029-1.117.038-1.99.029-.874-.01-1.903.068-3.087.234-.908.128-1.809.316-2.7.564.137-.248.514-.574 1.13-.978a96.929 96.929 0 012.19-1.39 116.31 116.31 0 002.64-1.693 17.246 17.246 0 002.444-1.929c.712-.681 1.245-1.377 1.6-2.087.353-.71.39-1.434.11-2.17-.286-.753-.86-1.254-1.724-1.503-.863-.249-1.804-.302-2.823-.159-.743.104-1.48.3-2.212.588a7.554 7.554 0 00-1.903 1.06c-.537.419-.93.892-1.179 1.42-.249.529-.265 1.078-.049 1.646.146.385.492.702 1.036.952s1.133.33 1.767.241a1.06 1.06 0 00.16-.036.95.95 0 01.16-.035c.208-.065.347-.12.417-.164.07-.045.112-.087.127-.124-.02-.05-.046-.082-.08-.094-.62-.107-1.016-.387-1.188-.838-.178-.469-.197-.92-.057-1.353.14-.434.377-.82.713-1.158.335-.338.75-.62 1.243-.848a5.587 5.587 0 011.566-.458c.799-.112 1.39-.063 1.775.148.384.21.64.483.767.817.23.602.107 1.236-.365 1.902-.472.665-1.13 1.339-1.972 2.021a46.953 46.953 0 01-2.797 2.084 75.029 75.029 0 00-2.848 2.065c-.877.669-1.6 1.325-2.167 1.969-.567.643-.801 1.249-.702 1.816.007.017.083.028.23.034.148.006.304-.003.47-.026.302-.042.524-.144.666-.305.223-.33.485-.557.787-.678.301-.122.728-.222 1.278-.299a9.162 9.162 0 011.802-.067c.622.035 1.25.084 1.882.145.632.061 1.274.108 1.924.14.65.032 1.292.004 1.925-.085z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0.515,
    x2: 3.388,
    y1: 6.262,
    y2: 18.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD891"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.515,
    x2: 3.388,
    y1: 6.262,
    y2: 18.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB9035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8B740"
  })))));
}

SvgPlaytechTwo.displayName = 'PlaytechTwo';
export default SvgPlaytechTwo;